/* eslint-disable no-useless-escape */
import { Injectable } from '@angular/core';
import { get as _get } from 'lodash';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';
import { MessageDetail, TemplatedEmail } from '@amfam/policy/models';
import { PrettyPolicyNum } from '@amfam/policy/pipes';
import { Agent } from '@amfam/shared/utility/agent';
import {
  Addressee,
  CommunicationService,
  InternalEmail
} from '@amfam/shared/utility/shared-services';

import { NotificationRequestInternalEmail } from './models';

@Injectable({
  providedIn: 'root'
})
export class GracePeriodnotificationService {
  constructor(private communicationService: CommunicationService) {}

  generateTemplateEmail(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    primaryEmail: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    accountEmail: any,
    customerName: string,
    agentId: string,
    partnerId: string,
    templateCode?: string,
    policyNumbers?: string
  ): TemplatedEmail {
    const recipientEmailAddress = primaryEmail || accountEmail;

    const messageDetails: MessageDetail[] = [];
    messageDetails.push({ key: 'EmailAddress', value: recipientEmailAddress.emailAddress });
    messageDetails.push({ key: 'SubscriberKey', value: recipientEmailAddress.emailAddress });
    messageDetails.push({ key: 'FirstName', value: customerName });
    messageDetails.push({ key: 'ProdID', value: agentId });
    if (policyNumbers) messageDetails.push({ key: 'PolicyNumber', value: policyNumbers });

    const customerEmailPayload = <TemplatedEmail>{
      templateCode: templateCode || 'AddVehicleSentToAgent',
      brandId: 'MyAccount',
      language: 'EN',
      partnerId: partnerId,
      recipientAddress: recipientEmailAddress.emailAddress,
      messageDetails
    };

    return customerEmailPayload;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public generateInternalEmails(model: NotificationRequestInternalEmail): Observable<any> {
    const email: InternalEmail = new InternalEmail();
    let emailAddress = _get(model, 'producer.agencyEmails[0]', _get(model, 'producer.emails[0]'));
    const internalAgentEmail = _get(model, 'producer.agencyEmails[0]')
      ? env.policyGracePeriodNotificatonInternalAgencyMailbox
      : env.policyGracePeriodNotificatonInternal;
    if (!env.production) {
      emailAddress = internalAgentEmail;
    }
    email.messageFrom = new Addressee('policy_change_request@amfam.com', 'Policy Change Request');
    email.messageToList.push(
      new Addressee(emailAddress, `${model.producer.firstName} ${model.producer.lastName}`)
    );
    email.messageSubject = model.subject || `Action Required: Your Customer Wants to Add a Vehicle`;
    email.messageContent =
      model.content || this.generateInternalEmailContent(model, model.producer, model.policyList);

    return this.communicationService.sendInternalEmail(email);
  }

  // Generate email content for ANS. ANS content cannot include HTML
  public generateInternalEmailContentANS(
    model: NotificationRequestInternalEmail,
    producer: Agent,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    policies: any[]
  ): string {
    let content = `Dear ${producer.firstName} ${producer.lastName},\n\n`;
    content += `One of your customers has submitted a New Vehicle Request.
    We don\'t have any details about the vehicle at this time, so please reach out to the customer for more information on what vehicle they would like to add and help them finalize this change to their policy.\n\n`;
    content += `The customer\'s information can be found below.\n\n`;
    content += `\n\nCustomer Information.\n`;
    content += `\nCustomer Name                       : ${model.firstName} ${model.lastName}\n`;
    content += `\nCustomer\'s Auto Policy Number`;
    if (policies.length > 1) {
      content += `s`;
    }
    content += `: `;
    policies.forEach((policy, index) => {
      if (policy.assignedProducer.producerIdNum === producer.id) {
        content += `${new PrettyPolicyNum().transform(policy)}`;
        if (++index !== policies.length) {
          content += `, `;
        }
      }
    });
    content += `\n\nCustomer\'s My Account Email Address : ${model.email}\n`;
    content += `\n`;
    content += `Thank you,\nMy Account Team`;
    return content;
  }

  private generateInternalEmailContent(
    model: NotificationRequestInternalEmail,
    producer: Agent,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    policies: any[]
  ): string {
    let content = `Dear ${producer.firstName} ${producer.lastName},<br>`;
    content += `Your customer has requested information on adding a vehicle to their policy. Please refer to the customer information below, and follow-up with the customer at your earliest convenience.<br><br>`;
    content += `<b>Customer Information:</b><br><hr/>`;
    content += `Customer Name                       : ${model.firstName} ${model.lastName}`;
    content += `<br>Policy Number`;
    if (policies.length > 1) {
      content += `s`;
    }
    content += `: `;
    policies.forEach((policy, index) => {
      if (policy.assignedProducer.producerIdNum === producer.id) {
        content += `${new PrettyPolicyNum().transform(policy)}`;
        if (++index !== policies.length) {
          content += `, `;
        }
      }
    });
    content += `<br><hr/><br>`;
    content += `Thank you,<br>The My Account Team<br><a href="mailto:ACCOUNTSUPPORT@amfam.com">ACCOUNTSUPPORT@amfam.com</a> `;
    return content;
  }
}
